import './styles.scss'
import { globalData } from '../..';
import { assetUrl, ID_NAMES, processGender, pushToDataLayer } from '../../env';
import showMessages from '../messages/showMessages';
import { toggleSound } from '../messages/sounds';

let messagesEnded = false;
let bubbleOpen = false;

const messagesOver = () => {
    messagesEnded = true;
}

const bubbleClick = () => {

    const layout = document.getElementById(ID_NAMES.LAYOUT)
    const chat = document.getElementById(ID_NAMES.CHAT)

    bubbleOpen = !bubbleOpen;

    if (bubbleOpen) {

        chat.style.display = 'flex'

        setTimeout(() => {
            layout.classList.add('chatheadVisible');
            chat.classList.add('chatheadVisible');
        }, 5)

        if (!messagesEnded) {
            showMessages();
        }

    } else {

        messagesOver()
        layout.classList.remove('chatheadVisible');
        chat.classList.remove('chatheadVisible');
        chat.style.display = 'none'

        toggleSound({ forceMute: true })

    }

}

const bubble = () => {

    let { displayType, messages, image } = globalData;

    const bubble = document.createElement("div");
    bubble.id = ID_NAMES.BUBBLE
    bubble.setAttribute("rel", "noreferrer")
    bubble.addEventListener("click", bubbleClick)
    bubble.addEventListener("click", () => {
        pushToDataLayer({
            eventCategory: 'homepage',
            eventLabel: 'chat head bubble'
        })
    })

    //MESSAGES TOTAL
    const messagesTotal = messages?.length;

    if (messagesTotal) {
        const messageDiv = document.createElement("div");
        messageDiv.id = 'chatheadMessageCount'
        messageDiv.textContent = messagesTotal
        bubble.append(messageDiv)
    }

    //AVATAR IMG 
    //USE MODEL THUMBNAL FOR DISPLAY TYPE: RANDOM
    const avatarSrc = displayType === 'random' ? processGender()?.thumbnail : assetUrl(image);
    const chatheadAvatar = document.createElement("img");
    chatheadAvatar.id = ID_NAMES.AVATAR
    chatheadAvatar.src = avatarSrc;
    chatheadAvatar.addEventListener("load", () => {

        //SHOW THE BUBBLE BOX WHEN THE MAIN AVATAR IMAGHE HAS FULLY LOADED
        const bubbleBox = document.getElementById(ID_NAMES.BUBBLE)
        bubbleBox.classList.add('chatheadShowBubble');

    })
    bubble.append(chatheadAvatar)

    //ADD BUBBLE TO THE MAIN PARENT
    const layout = document.getElementById(ID_NAMES.LAYOUT)
    layout.append(bubble)

    //RESIZE TOP
    const resize = () => {
        if (window.innerHeight < 600) {
            layout.classList.add('forceTop');
        } else {
            layout.classList.remove('forceTop');
        }
    }

    window.addEventListener("resize", resize)
    resize()

}

export { bubbleClick, messagesOver }
export default bubble